// extracted by mini-css-extract-plugin
export default {"modalOverlay":"HF-z","modalContent":"IF-z","header":"JF-z","close":"KF-z"};